import script from "./Process.vue?vue&type=script&lang=ts&setup=true"
export * from "./Process.vue?vue&type=script&lang=ts&setup=true"

import "./Process.vue?vue&type=style&index=0&id=2f5c78b0&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5c78b0"]])

export default __exports__